//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const FormJsonSerializerPageVisibility: FeatureFlag = {"Id":"FormJsonSerializerPageVisibility","Label":"(KILL)[10.27]FormJsonSerializerPageVisibility","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Pass an explicit visibility type into the top-level page visibility check when writing form JSON","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
